// Ana sayfa hizmet kartları verisi.
// desc: kart altında gösterilen kısa SEO metni
// to: ilgili hizmet sayfası (varsa); yoksa genel servisler sayfası

const services = [
  {
    image: require("../images/kombi-update.png"),
    title: "Kombi Tamir",
    desc: "Tüm marka kombilerde arıza tespiti ve aynı gün onarım hizmeti.",
    to: "/servislerimiz",
  },
  {
    image: require("../images/kombi-bakım-updated2.png"),
    title: "Kombi Bakım",
    desc: "Periyodik kombi bakımı ile verimli, güvenli ve tasarruflu ısınma.",
    to: "/servislerimiz",
  },
  {
    image: require("../images/petek-temizleme-updated.png"),
    title: "Petek Temizleme",
    desc: "Petek (radyatör) temizliği ile daha hızlı ısınan, ekonomik sistem.",
    to: "/servislerimiz",
  },
  {
    image: require("../images/air-conditioning.jpg"),
    title: "Klima Servisi",
    desc: "Klima bakımı, gaz dolumu ve montaj. Sağlıklı ve serin bir ortam.",
    to: "/servislerimiz/klima-bakimi",
  },
  {
    image: require("../images/camasır-makinesi-updated.png"),
    title: "Çamaşır Makinesi Tamir",
    desc: "Çamaşır makinesi arızalarında profesyonel ve garantili tamir.",
    to: "/servislerimiz",
  },
  {
    image: require("../images/bulasik-makinesi-updated2.png"),
    title: "Bulaşık Makinesi Tamir",
    desc: "Bulaşık makinesi arıza ve bakımında uzman ekip çözümü.",
    to: "/servislerimiz",
  },
  {
    image: require("../images/buzdolabı-updated.jpg"),
    title: "Buzdolabı Tamir",
    desc: "Soğutmayan buzdolaplarına hızlı, garantili soğutucu onarımı.",
    to: "/servislerimiz",
  },
];

export default services;
